import { useTranslation } from "react-i18next";
import { formatDate, formatDateTime } from "@/shared/utils/formatters";

/**
 * Returns locale-aware date formatting helpers bound to the currently
 * active i18n language.  Drop-in replacements for the raw `formatDate`
 * and `formatDateTime` utilities inside React components.
 *
 * @example
 *   const { fmtDate, fmtDateTime } = useFormatDate();
 *   fmtDate(record.flight_date)  // "Jan 5, 2025"  (en) | "2025年1月5日"  (ja)
 */
export const useFormatDate = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return {
    fmtDate: (dateStr: string) => formatDate(dateStr, lang),
    fmtDateTime: (dateStr: string) => formatDateTime(dateStr, lang),
  };
};
